// extracted by mini-css-extract-plugin
module.exports = {"receivedAction":"paymentActionColumn_receivedAction__3LZ9o","refundedAction":"paymentActionColumn_refundedAction__1w_jV","removedAction":"paymentActionColumn_removedAction__3PLRv"};